// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__i3W-f","content":"modal_content__wZVbb"};